import css from './index.module.scss';
import Series from './Series';
import { useGlobal } from '@/utils/useGlobal';

export default function LSmart() {
    const { useLang, Link } = useGlobal();
    const { t } = useLang('vanlife');
    const seriesData: any[] = [
        {
            key: 'wave2',
            title: t('secL_smart_wave2_title'),
            desc: t.rich('secL_smart_wave2_desc', {
                a: (text: string) => (
                    <Link className="desc-link" href={t('secL_smart_wave2_desc_link')}>
                        {text}
                    </Link>
                ),
            }),
            img: '/responsive/picture/vanlife/11_2_1.jpg',
            tables: [
                {
                    tableTitle: t('secL_smart_wave2_table1_title'),
                    tableContent: [
                        [t('secL_smart_table_menu1'), t('secL_smart_wave2_table1_content_row1_col1')],
                        [t('secL_smart_table_menu2'), t('secL_smart_wave2_table1_content_row2_col1')],
                        [t('secL_smart_table_menu3'), t('secL_smart_wave2_table1_content_row3_col1')],
                        [t('secL_smart_table_menu4'), t('secL_smart_wave2_table1_content_row4_col1')],
                        [t('secL_smart_table_menu5'), t('secL_smart_wave2_table1_content_row5_col1')],
                        [t('secL_smart_table_menu6'), t('secL_smart_wave2_table1_content_row6_col1')],
                        [t('secL_smart_table_menu7'), t('secL_smart_wave2_table1_content_row7_col1')],
                        [t('secL_smart_table_menu8'), t('secL_smart_wave2_table1_content_row8_col1')],
                        [t('secL_smart_table_menu9'), t('secL_smart_wave2_table1_content_row9_col1')],
                        [t('secL_smart_table_menu10'), t('secL_smart_wave2_table1_content_row10_col1')],
                        [t('secL_smart_table_menu11'), t('secL_smart_wave2_table1_content_row11_col1')],
                        [t('secL_smart_table_menu12'), t('secL_smart_wave2_table1_content_row12_col1')],
                        [t('secL_smart_table_menu13'), t('secL_smart_wave2_table1_content_row13_col1')],
                    ],
                },
            ],
            note: t.rich('secL_smart_wave2_table1_note', {
                a: (text: string) => (
                    <Link className="note-link" href={t('secL_smart_wave2_desc_link')}>
                        {text}
                    </Link>
                ),
            }),
        },
    ];
    return (
        <div id="vanlife-L-smart" className={`vanlife-L-smart ${css['vanlife-L-smart']}`}>
            <h3 className="title">{t('secL_smart_title')}</h3>
            <p className="text desc-h3">{t('secL_smart_desc')}</p>
            {seriesData?.map((data: any, k: number) => (
                <Series key={k} data={data} />
            ))}
        </div>
    );
}
